import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { EtapaOcorrencia } from 'src/app/models/etapa-ocorrencia';
import { Funcionario } from 'src/app/models/funcionario';
import { LogEtapaOcorrencia } from 'src/app/models/log-etapa-ocorrencia';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { IntervaloDeTempoService } from 'src/app/services/intervalo-de-tempo.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { OcorrenciaService } from 'src/app/services/ocorrencia.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-log-etapa-ocorrencia-modal',
  templateUrl: './log-etapa-ocorrencia-modal.component.html',
  styleUrls: ['./log-etapa-ocorrencia-modal.component.scss']
})
export class LogEtapaOcorrenciaModalComponent implements OnInit {
  idOcorrencia: number;
  logsOcorrencia: LogEtapaOcorrencia[] = [];
  integrador: Funcionario = new Funcionario();
  campoOrdenacao = 'dataHora';
  ordenarDesc = false;
  usuarioLogado: UsuarioLogado;
  vendedor = false;
  etapasOcorrencia: EtapaOcorrencia[] = [];
  tempoEstimado: number = 0;
  duracao: number = 0;
  dataDuracao: Date;
  concluido: boolean = false;
  venceu: boolean = false;
  tempoDeAtraso: string;
  tempoDeDuracao: string;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<LogEtapaOcorrenciaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ocorrenciaService: OcorrenciaService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private utilitarioService: UtilitarioService
  ) {
    this.idOcorrencia = data.idOcorrencia;
    this.vendedor = data.vendedor;
    this.etapasOcorrencia = data.etapas;
    this.dataDuracao = data.duracao;
    this.concluido = data.concluido;
  }

  ngOnInit() {
    this.buscarLogsEtapa();
  }

  buscarLogsEtapa() {
    this.carregandoService.mostra("buscaOcorrencia");
    this.ocorrenciaService.consultarLogsEtapaOcorrencia(this.idOcorrencia).subscribe(data => {
      this.logsOcorrencia = data;
      this.calculaTempo();
      this.carregandoService.esconde("buscaOcorrencia");
    }, (erro) => {
      this.carregandoService.esconde("buscaOcorrencia");
      this.notificacaoService.erro("Não foi possível buscar os logs");
    });
  }

  calculaTempo() {
    if (this.etapasOcorrencia && this.etapasOcorrencia.length > 0) {
      this.etapasOcorrencia.forEach(etapa => {
        if (etapa.tempoEstimado) {
          this.tempoEstimado += etapa.tempoEstimado;
        }
      });
    }

    this.tempoDeAtraso = this.dataHumanizada(this.dataDuracao);
    const temp = this.logsOcorrencia.length > 0 && this.concluido ? new Date(this.logsOcorrencia[this.logsOcorrencia.length - 1].dataHora) : new Date();
    const temp2 = new Date(this.dataDuracao);
    this.duracao = this.utilitarioService.retornaDiferencaDeHoras(temp, temp2);
    this.venceu = this.duracao > this.tempoEstimado;
    this.tempoDeDuracao = this.utilitarioService.retornaDiferencaDeHorasTimeSpan(temp, temp2);
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  fechar() {
    this.dialogRef.close();
  }

  dataHumanizada(data): string {

    if (data === null || data === undefined || !data)
      return '';

    data = data.toString();

    const now = new Date();
    const dateNasc = new Date(data);
    const diff = now.getTime() - dateNasc.getTime();

    const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
    const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    const textYears = years > 1 ? 'anos' : 'ano';
    const textDays = days > 1 ? 'dias' : 'dia';
    const textHours = hours > 1 ? 'horas' : 'hora';

    let result = '';

    if (years > 0) {
      result += `${years} ${textYears}`;
    }

    if (days > 0) {
      if (result.length > 0) {
        result += ', ';
      }
      result += `${days} ${textDays}`;
    }

    if (hours > 0) {
      if (result.length > 0) {
        result += ' e ';
      }
      result += `${hours} ${textHours}`;
    }

    if (result.length === 0) {
      result = '0 horas';
    }

    return result + ' atrás';
  }
}
